import { useAuthStore } from "@/store/auth-store";
import type { UserPassWithDetails } from "@/types/UserPass";
import type { UserSubscriptionWithDetails } from "@/types/UserSubscription";
import useSWR from "swr";

export function useCheckoutUserPassesSubscriptions() {
  const { isAuthenticated, user } = useAuthStore();

  const key =
    isAuthenticated && user?.id
      ? `/api/widget/profile/${user?.id}/passes-subscriptions`
      : null;

  const { data, error, isLoading, mutate } = useSWR<{
    passes: UserPassWithDetails[];
    subscriptions: UserSubscriptionWithDetails[];
  }>(key);

  const passes =
    data?.passes.filter(
      (pass) =>
        pass.status === "ACTIVE" &&
        (pass.creditsRemaining === null || pass.creditsRemaining > 0),
    ) ?? [];

  return {
    passes,
    subscriptions: data?.subscriptions ?? [],
    isLoading,
    error,
    refresh: mutate,
  };
}
